'use strict';

(function ($, Drupal) {
  Drupal.behaviors.mobileNav = {
    attach: function (context) {
      var owlOn = false;
      owlOn = ccoResize(context, owlOn);
      $(window).on('resize', function() {
        owlOn = ccoResize(context, owlOn);
      });
    }
  }
  function ccoResize(context, owlOn) {
    var w = $(window).width();
    if(w < 768) {
      if(!owlOn) {
        $('.cco_items',context).each(function() {
          $(this).owlCarousel({
            items: 1,
            nav:true,
            dots: false,
            loop: false,
            navText: [
              '<span aria-label="Previous" class="fas fa-chevron-left"></span>',
              '<span aria-label="Next" class="fas fa-chevron-right"></span>'
            ]
          });
          owlOn = true;
        });
      }
    } else {
      if(owlOn) {
        $('.cco_items',context).each(function() {
          $(this).owlCarousel('destroy');
        });
        owlOn = false;
      }
    }

    return owlOn;
  }
})(jQuery, Drupal);
